<app-spinner-service></app-spinner-service>

<app-toolbar-search 
  [showDateFilters]="true" 
  [showDownloadButton]="true" 
  [(dataInicio)]="dataInicio"
  [(dataFim)]="dataFim" 
  (onDateChange)="filtrarPorData()" 
  (onDownload)="downloadExcel()"
  (onSearch)="applyFilterGlobal($event)" 
  placeholder="Pesquisar faturamentos...">
</app-toolbar-search>

<p-table #dt 
  [value]="faturamentosComPropriedadesOrdenacao" 
  [paginator]="true" 
  [rows]="50"
  [globalFilterFields]="['dataEmissao', 'cnpjCpfTomador', 'nomeTomador', 'numeroNfse', 'codigoServico', 'descricaoCodigoServico', 'valor']"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
  class="custom-table"
  [loading]="loading"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[5, 10, 20, 50]"
  sortField="dataEmissao"
  [sortOrder]="-1">

  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="dataEmissao" style="width: 12%">
        Data de Emissão <p-sortIcon field="dataEmissao"></p-sortIcon>
      </th>
      <th pSortableColumn="cnpjCpfTomador" style="width: 15%">
        CNPJ/CPF do Tomador <p-sortIcon field="cnpjCpfTomador"></p-sortIcon>
      </th>
      <th pSortableColumn="nomeTomador" style="width: 20%">
        Nome do Tomador <p-sortIcon field="nomeTomador"></p-sortIcon>
      </th>
      <th pSortableColumn="numeroNfse" style="width: 12%">
        Número da NFS-e <p-sortIcon field="numeroNfse"></p-sortIcon>
      </th>
      <th pSortableColumn="codigoServico" style="width: 12%">
        Código Serviço <p-sortIcon field="codigoServico"></p-sortIcon>
      </th>
      <th pSortableColumn="descricaoCodigoServico" style="width: 20%">
        Descrição do Serviço <p-sortIcon field="descricaoCodigoServico"></p-sortIcon>
      </th>
      <th pSortableColumn="valor" style="width: 9%; text-align: center;">
        Valor <p-sortIcon field="valor"></p-sortIcon>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-faturamento>
    <tr>
      <td>
        <div class="date-content">
          <i class="pi pi-calendar date-icon"></i>
          <span class="date-text" [pTooltip]="formatarDataExibicao(faturamento.dataEmissao)" tooltipPosition="top">{{ formatarDataExibicao(faturamento.dataEmissao) }}</span>
        </div>
      </td>
      <td>
        <div class="document-content">
          <i class="pi pi-id-card document-icon"></i>
          <span class="document-text" [pTooltip]="faturamento.cnpjCpfTomador" tooltipPosition="top">{{ faturamento.cnpjCpfTomador }}</span>
        </div>
      </td>
      <td>
        <div class="client-content">
          <i class="pi pi-user client-icon"></i>
          <span class="client-text" [pTooltip]="faturamento.nomeTomador" tooltipPosition="top">{{ faturamento.nomeTomador }}</span>
        </div>
      </td>
      <td>
        <div class="nfse-content">
          <i class="pi pi-receipt nfse-icon"></i>
          <span class="nfse-text" [pTooltip]="faturamento.numeroNfse" tooltipPosition="top">{{ faturamento.numeroNfse }}</span>
        </div>
      </td>
      <td>
        <div class="code-content">
          <i class="pi pi-tag code-icon"></i>
          <span class="code-text" [pTooltip]="faturamento.codigoServico" tooltipPosition="top">{{ faturamento.codigoServico }}</span>
        </div>
      </td>
      <td>
        <div class="description-content">
          <i class="pi pi-align-left description-icon"></i>
          <span class="description-text" [pTooltip]="faturamento.descricaoCodigoServico" tooltipPosition="top">{{ faturamento.descricaoCodigoServico }}</span>
        </div>
      </td>
      <td class="text-center">
        <div class="value-content">
          <i class="pi pi-dollar value-icon"></i>
          <span class="value-text" [pTooltip]="faturamento.valor | currency:'BRL':'symbol':'1.2-2'" tooltipPosition="top">{{ faturamento.valor | currency:'BRL':'symbol':'1.2-2' }}</span>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="7" class="empty-message">
        <div class="empty-content">
          <i class="pi pi-chart-line" style="font-size: 3rem; color: #6c757d; margin-bottom: 1rem;"></i>
          <h3>Nenhum faturamento encontrado</h3>
          <p>Não há dados de faturamento para o período selecionado.</p>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>